import React from "react";
import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";
import "./CircularLoadingIndicator.css";
function CircularLoadingIndicator() {
  const theme = useThemeHook();
  return (
    <div className="loading-container">
      <div
        style={{
          border: "5px solid " + THEME_COLORS[theme].less_theme,
          borderTop: "5px solid " + THEME_COLORS[theme].inverse_theme,
        }}
        className="loading-indicator"
      ></div>
    </div>
  );
}

export default CircularLoadingIndicator;
